export const visitorBodyParameters = ({
                                          isRegistration,
                                          exhibitionId,
                                          exhibitorId,
                                          visitorId,
                                          isUpdate,
                                          sendMessages
                                      }, values) => {
    return ({
        ExhibitionId: exhibitionId,
        ...(values.id && isUpdate ? {ContactId: values.id} : {}),
        ...(isRegistration ? {isRegistration: isRegistration} : {}),
        ...(sendMessages ? {sendMessages: sendMessages} : {}),
        ...(visitorId ? {id: visitorId} : {}),
        ...(values.characterization ? {
            CharacterizationId: values.characterization && values.characterization.id ? values.characterization.id : "",
            CharacterizationDescription: values.characterization && values.characterization.id ? values.characterization.text : ""
        } : {}),
        ...(values.city ? {City: values.city} : {}),
        ...(values.companyAddress ? {CompanyAddress: values.companyAddress} : {}),
        ...(values.companyName ? {CompanyName: values.companyName} : {}),
        ...(values.companyWebsite ? {CompanyWebSite: values.companyWebsite} : {}),
        ...(values.instagram ? {Instagram: values.instagram} : {}),
        ...(values.facebook ? {Facebook: values.facebook} : {}),
        ...(values.instagram ? {Instagram: values.instagram} : {}),
        ...(values.facebook ? {Facebook: values.facebook} : {}),
        ...(values.countries ? {CountryId: values.countries && values.countries.id ? values.countries.id : ''} : {}),
        ...(values.email ? {email: values.email} : {}),
        ...(values.hasRevisited ? {hasRevisited: values.hasRevisited} : {}),
        ...(values.interests ? {Interests: values.interests.length > 0 ? values.interests.map(v => v.id).toString() : ""} : {}),
        ...(values.isIndividual ? {isIndividual: values.isIndividual} : {}),
        ...(values.mobilePhone ? {MobilePhone: values.mobilePhone} : {}),
        ...(values.name ? {Name: values.name} : {}),
        ...(values.otherInterests ? {OtherInterests: values.otherInterests} : {}),
        ...(values.personCount ? {PersonCount: values.personCount} : {}),
        ...(values.phone ? {Phone: values.phone} : {}),
        ...(values.position ? {Position: values.position} : {}),
        ...(values.postalCode ? {PostalCode: values.postalCode} : {}),
        ...(values.vatNumber ? {VatNumber: values.vatNumber} : {}),
    })
}

export const searchFieldMappings = {
    vatNumber: "vatNumber",
    name: "Name",
    email: "email",
    mobilePhone: "MobilePhone",
    companyName: "CompanyName",
    phone: "Phone",
}

export const findCountryCode = (currentPhoneCode, mobilePhone, phoneCodes) => {
    let countryPhoneCode = null
    if(!String(mobilePhone).startsWith(currentPhoneCode)) {
        let found = false;
        let foundAt = 0;
        for(let i = 0; i < phoneCodes.length; i++) {
            if(phoneCodes[i].phoneCode !== '' && String(mobilePhone).startsWith(phoneCodes[i].phoneCode)) {
                if(!found){
                    foundAt = i;
                    found = true;
                }
                else{
                    found = false;
                    break;
                }
            }
        }
        if(found) {
            countryPhoneCode = phoneCodes[foundAt]
        }
    }
    return countryPhoneCode
}


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
}

export const showOption = (language) => (option) => {
    if (typeof option === 'string') {
        return option
    }
    if (typeof option.description === 'string') {
        return option.description
    }
    return option.description[language]
}
